module.exports = {
  title: '鸿坚网购-平台管理',

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   * 暂时没使用
   */
  showSettings: false,

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   * 暂时没使用
   */
  errorLog: 'production'
}



// WEBPACK FOOTER //
// ./src/settings.js